import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  NFT_INVENTORY_VALID_UPDATE_REQUEST
} from '../../constants/inventory/nftInventoryValidUpdateConstants';
import {
  BaseResponse,
  InventoryApi, InventoryControllerDtoNftInventoryValidUpdateRequest
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new InventoryApi(config.API_CLIENT);

function* nftInventoryValidUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new InventoryControllerDtoNftInventoryValidUpdateRequest();
    requestData.nftInventoryNo = payload.nftInventoryNo;
    requestData.valid = payload.valid;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiInventoryNftInventoryValidUpdatePost({ inventoryControllerDtoNftInventoryValidUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftInventoryValidUpdateRootSaga() {
  yield all([
    takeEvery(NFT_INVENTORY_VALID_UPDATE_REQUEST, nftInventoryValidUpdateRequestSaga),
  ]);
}
const nftInventoryValidUpdateSagas = [fork(nftInventoryValidUpdateRootSaga)];

export default nftInventoryValidUpdateSagas;
